import { render } from "./ImportsHistory.vue?vue&type=template&id=3b6d1bb6&scoped=true"
import script from "./ImportsHistory.vue?vue&type=script&lang=js"
export * from "./ImportsHistory.vue?vue&type=script&lang=js"

import "./ImportsHistory.vue?vue&type=style&index=0&id=3b6d1bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6d1bb6"]])

export default __exports__